import { render, staticRenderFns } from "./GlabalChunkNo.vue?vue&type=template&id=5e055a78&scoped=true"
import script from "./GlabalChunkNo.vue?vue&type=script&lang=js"
export * from "./GlabalChunkNo.vue?vue&type=script&lang=js"
import style0 from "./GlabalChunkNo.vue?vue&type=style&index=0&id=5e055a78&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e055a78",
  null
  
)

export default component.exports